export default __webpack_public_path__ + "static/media/pow-13.e0a319ff.jpg";